import getCanvas from '../helpers/getCanvas';

const clearForm = (html) => {
  const canvas = getCanvas(html);
  const newForm = document.createElement('form');
  const elementsSelector = 'input, textarea, select, button';

  const oldForm = canvas.querySelector('form');
  const scripts = canvas.querySelectorAll('script');

  if (!oldForm) {
    return html;
  }

  const elements = oldForm.querySelectorAll(elementsSelector);

  newForm.setAttribute('method', 'POST');
  newForm.setAttribute('action', oldForm.getAttribute('action'));

  Array.from(elements).forEach((element) => {
    element.removeAttribute('style');
    element.removeAttribute('class');

    newForm.appendChild(element);
  });

  Array.from(scripts).forEach((script) => {
    newForm.appendChild(script);
  });

  return newForm.outerHTML;
};

export default clearForm;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/clearForm.js
 **/